import "./main.scss";

import { BrowserRouter as Router, useLocation } from "react-router-dom";

import { PaymentProvider } from "./providers/payment/payment.provider";

import { setAppToken } from "./setup/context/api";
import React, { Suspense, useEffect } from "react";
const NavBar = React.lazy(() => import("./components/navbar"));
const Routes = React.lazy(() => import("./setup/routes"));
const ProfileProvider = React.lazy(() => import("./providers/profile"));

// styles
import styles from "./App.module.scss";
import useLocalStorage from "./hooks/useLocalStorage/useLocalStorage";

export const App = () => {
  const [userToken] = useLocalStorage<string | null>("userToken", null);

  useEffect(() => {
    setAppToken();
  }, []);

  return (
    <div
      className={!userToken ? styles["auth_container"] : styles["container"]}
      dir="rtl">
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      />
      <Suspense fallback={<div />}>
        <ProfileProvider>
          <PaymentProvider>
            <Router>
              <AppContent />
            </Router>
          </PaymentProvider>
        </ProfileProvider>
      </Suspense>
    </div>
  );
};

const AppContent = () => {
  const location = useLocation();

  // Check if the current path matches the pattern "/external/:id"
  const isExternalRoute = /^\/external\/[^/]+$/.test(location.pathname);
  // Check if `redirect_url` is present in the query parameters
  const searchParams = new URLSearchParams(location.search);
  const hasRedirectUrl = searchParams.has("redirect_url");

  return (
    <>
      {!(isExternalRoute || hasRedirectUrl) && <NavBar />}
      <Routes />
    </>
  );
};
